<a
  href="#"
  (click)="OnChooseCatalogLang($event)"
  class="catalog-language-selector d-flex m-1 position-absolute font-size-header font-weight-bold button dark"
  [ngClass]="
    isRtl ? 'catalog-language-selector-rtl' : 'catalog-language-selector'
  "
  *ngIf="
    (selectedLang$ | async) &&
    (availableCatalogLanguages$ | async)?.data?.length > 1
  "
  [ngClass]="{
    'catalog-language-selector-child': shouldDisplaySiblingSelection(),
  }"
>
  <i class="fas fa-globe mr-1"></i>
  <span class="">{{ selectedLang | uppercase }}</span>
</a>
<div
  class="catalog-language-selector-container d-flex flex-wrap justify-content-end align-items-start hide"
  [ngStyle]="{
    'background-color':
      langSelectorModal.style.display === 'block'
        ? 'rgba(0,0,0,0.38)'
        : 'rgba(0,0,0,0.38)',
  }"
  #refEl
  (click)="OnCheckOutsideClose($event, refEl)"
  #langSelectorModal
>
  <div class="selection-container">
    <div
      class="language-container d-flex flex-wrap"
      *ngIf="availableCatalogLanguages && selectedLang"
    >
      <form [formGroup]="langSelectionForm">
        <div
          class="radio leading d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
        >
          <label
            [attr.for]="language.name"
            class="d-flex w-100 container font-size-primary"
            *ngFor="let language of availableCatalogLanguages"
            >{{ language.name }}
            <input
              type="radio"
              name="availableCatalogLanguages"
              formControlName="availableCatalogLanguages"
              value="{{ language.locale }}"
              [attr.id]="language.name"
              (click)="newLang = language.locale"
            />
            <span class="checkmark"></span>
          </label>
        </div>
      </form>
    </div>
    <div class="button-container secondary-action-row justify-content-end">
      <app-button variant="secondary" (click)="OnCloseLangModal($event)">
        {{ 'public.dialog.cancel' | translate }}
      </app-button>

      <app-button
        variant="dark"
        size="small"
        dataTestid="language-selector-ok-button"
        (click)="setNewCatalogLanguage($event)"
      >
        {{ 'public.dialog.ok' | translate }}
      </app-button>
    </div>
  </div>
</div>
